export const setting = state => key => state.settings[key] ? state.settings[key] : null
export const permissions = state => key => {
	if (!state.settings.permissions) {
		// Initialize default permissions structure if not exists
		return {
			consulterPOF: false,
			editerPOF: false,
			renoverPOF: false,
			creerPOF: false,
			supprimerFichierPOF: false,
			supprimerPOF: false
		}
	}
	return state.settings.permissions[key] ? state.settings.permissions[key] : {
		consulterPOF: false,
		editerPOF: false,
		renoverPOF: false,
		creerPOF: false,
		supprimerFichierPOF: false,
		supprimerPOF: false
	}
}
export const roles = state => state.settings.roles ? state.settings.roles.map(role => role) : []
export const areas = state => state.settings.areas ? state.settings.areas.map(area => area) : []
// export const roles = state => state.settings.roles.map(role => role)
export const lang = state => state.settings.lang ? state.settings.lang : 'en'
export const token = state => state.token
// shiseido data
export const dataready = state => state.options.brand.length && Object.keys(state.projects)
export const projects = state => state.indexes.map(id => state.projects[id]) || []
export const options = state => state.options
export const option = state => (name, id) => state.options[name].filter(o => o.id === id)
export const optionsLoaded = state => state.optionsLoaded
export const optionId = state => (name, value) => {
	const prop = state.options[name] ? state.options[name].find(o => o.label === value) : null
	return prop ? prop.id : null
}
export const filterOptions = state => key => state.options[key] || []
export const project = state => id => state.projects[id]
export const projectProp = state => (id, key) => state.projects[id][key]
export const projectPicture = state => id => state.projects[id].avatarFile
export const typeOfProjectPerso = state => id => state.projects[id].typeOfProject.personalization
export const typeOfProjectItems = state => id => state.projects[id].typeOfProject.items
export const typeOfProjectType = state => id => state.projects[id].typeOfProject.type
export const countries = state => state.options.country ? state.options.country.filter(c => c.lat && c.lon) : []
export const suppliers = state => {
	const projects = state.indexes.map(id => state.projects[id]) || []
	return [...new Set(projects.map(p => p.supplier))]
}
export const projectsFileDownload = state => state.projectsFile.length ? state.projectsFile : false
/* ZONES */
export const supplierManufacturers = state => array => state.options.supplierManufacturer.filter(supplier => array.includes(supplier.id))
/* /ZONES */

// project keys
export const area = state => id => state.options.area.find(a => a.id === id)
/* ZONES */
export const zone = state => id => state.options.zone.find(z => z.id === id)
/* /ZONES */
export const brand = state => id => state.options.brand.find(b => b.id === id)
export const brandCollection = state => id => state.options.brandCollection.find(b => b.id === id)
export const country = state => id => state.options.country.find(c => c.id === id)
export const distributionChannel = state => id => state.options.distributionChannel.find(dc => dc.id === id)
export const generalFloorPlan = state => id => state.options.generalFloorPlan.find(gfp => gfp.id === id)
export const groupSpacePlan = state => id => state.options.groupSpacePlan.find(gsp => gsp.id === id)
export const projectLabel = state => id => state.options.typeOfProjectLabel.find(l => l.id === id)
export const projectStatus = state => id => state.options.projectStatus.find(ps => ps.id === id)
export const projectType = state => id => state.options.typeOfProjectType.find(pt => pt.id === id)
export const specificNeed = state => id => state.options.specificNeed.find(sn => sn.id === id)
export const step = state => id => state.options.step.find(s => s.id === id)
export const supplierManufacturer = state => id => state.options.supplierManufacturer.find(s => s.id === id)
export const typeOfStore = state => id => state.options.typeOfStore.find(st => st.id === id)
export const budget = state => id => state.options.budgetInK.find(bd => bd.id === id)

// Filter getters
export const filters = state => state.filters
export const filter = state => key => state.filters[key]



// WEBPACK FOOTER //
// ./src/store/getters.js